import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

/**
 * @typedef {import('./js-doc').V2BatchCreateBuyoutsRequest} V2BatchCreateBuyoutsRequest
 * @typedef {import('./js-doc').V2UpdateInvoiceRequest} V2UpdateInvoiceRequest
 * @typedef {import('./js-doc').V2PurchaseInvoiceRequest} V2PurchaseInvoiceRequest
 * @typedef {import('./js-doc').V2RejectInvoiceRequest} V2RejectInvoiceRequest
 * @typedef {import('./js-doc').V2VerifyInvoiceRequest} V2VerifyInvoiceRequest
 * @typedef {import('./js-doc').V2DeleteInvoiceRequest} V2DeleteInvoiceRequest
 * @typedef {import('./js-doc').V2RevertInvoiceRequest} V2RevertInvoiceRequest
 * @typedef {import('./js-doc').V2RegenerateInvoiceDocumentRequest} V2RegenerateInvoiceDocumentRequest
 * @typedef {import('./js-doc').V2InvoiceResponse} V2InvoiceResponse
 * @typedef {import('./js-doc').V2PossibleDuplicatesResponse} V2PossibleDuplicatesResponse
 */

class Buyout {
  constructor () {
    this.baseURL = 'buyouts'
  }

  /**
   * @param {V2BatchCreateBuyoutsRequest} v2Request - V2 batch
   * @returns {Promise<void>} V2 response body
   */
  async create (v2Request) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).post('', v2Request)
      return result?.data
    }
    catch (error) {
      CError('Could not create invoice in V2 API', error)
      throw error
    }
  }
}

export default Buyout
